import Dashboard from "@/common/components/layout/Dashboard";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import { Toast } from "flowbite-react";
import ChatService from "./ChatService";

export default function DashboardChatService() {
  return (
    <ToastProvider>
      <Dashboard>
        <ChatService />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
